<template>
  <div class="section">
    <div class="sectionTitle flexAfter">
      <div data-automation="activity-title">
        Activity Log
      </div>
      <div
        v-if="currentRepoSources && currentRepoSources.length > 1"
        class="menu inSectionHeader"
      >
        <div class="menuLabel">
          Source
        </div>
        <div class="menuItems">
          <select
            v-model="selectedSource"
            data-automation="activity-sources"
            class="changeSourceSelect"
          >
            <option
              v-for="source in currentRepoSources"
              :key="source.name"
              :value="source"
            >
              {{ source.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <TransactionsList
      :transactions="allTransactions"
      :enable-expansion="false"
      :show-local-t-z="false"
      :date-header="dateHeader()"
      :python="true"
    />
    <GetMoreButton
      v-if="showGetNext"
      id="e2e-get-more-transactions"
      label="List more actions"
      @getMore="getNextTransactions"
    />
    <GettingMore
      :show="gettingTransactions"
      label="Getting snapshots"
    />
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'

import { serverPath } from '../../api/http-common'

import TransactionsList from '../TransactionsList'
import GetMoreButton from '../GetMoreButton'
import GettingMore from '../GettingMore'
import * as types from '../../store/mutation-types'

export default {
  name: 'ActivityPython',
  components: {
    TransactionsList,
    GetMoreButton,
    GettingMore,
  },
  computed: {
    rDocURL: function () {
      return `${serverPath()}__docs__/admin/building-packages.html#r-configuration`
    },
    selectedSource: {
      get () {
        return this.currentRepoSources.find(s => this.currentRepoSource === s.id)
      },
      set (source) {
        this.setSource(source)
      },
    },
    showLocalTZ: function () {
      // At time of writing, we don't have any reason to show local timezone. We want UTC to simplify
      //   having a common time reference for our checkpoint data.
      return false
    },
    ...mapGetters(['getWindow']),
    ...mapState({
      gotRepos: state => state.repos.gotRepos,
      currentRepoId: state => state.repos.currentRepoId,
      currentRepoSources: state => state.repos.currentRepoSources,
      currentRepoSource: state => state.repos.currentRepoSource,
      currentRepoSourceType: state => state.repos.currentRepoSourceType,
      gettingTransactions: state => state.transactions.gettingTransactions,
      allTransactions: state => state.transactions.allTransactions,
      transactionsCount: state => state.transactions.transactionsCount,
      exposed: state => state.repos.currentRepoNextSyncExposed,
      priorSync: state => state.repos.currentRepoNextSyncPriorSync,
      status: state => state.status,
    }),
    showGetNext: function () {
      return !this.gettingTransactions && (this.transactionsCount > this.allTransactions.length)
    },
  },
  watch: {
    currentRepoSource: function (value) {
      if (value) {
        this.$store.dispatch('getFirstTransactions', { sourceId: value })
      }
    },
    currentRepoId: function (value) {
      if (value) {
        this.$store.dispatch('getFirstTransactions', { sourceId: this.currentRepoSource })
      }
    },
  },
  created: function () {
    if (this.gotRepos) {
      this.getFirstTransactions()
    }
  },
  beforeRouteUpdate (to, from, next) {
    // Reload the transactions when the repository ID changes
    if (this.gotRepos && to.params.repoId !== from.params.repoId) {
      this.getFirstTransactions()
    }
    next()
  },
  mounted: function () {
    this.$store.commit(types.SET_CURRENT_NAV, 'activity')
  },
  beforeDestroy: function () {
    if (this.timerId) {
      this.getWindow.clearInterval(this.timerId)
    }
  },
  methods: {
    setSource: function (source) {
      this.$store.commit(types.SET_CURRENT_SOURCE, source)
    },
    getFirstTransactions: function (event) {
      if (this.currentRepoSource) {
        this.$store.dispatch('getFirstTransactions', { sourceId: this.currentRepoSource })
      }
    },
    getNextTransactions: function (event) {
      if (this.currentRepoSource) {
        this.$store.dispatch('getNextTransactions', { sourceId: this.currentRepoSource })
      }
    },
    dateHeader: function () {
      return this.showLocalTZ ? 'Published' : 'Snapshot Date'
    },
  },
}

</script>

<style scoped>
.changeSourceSelect {
  min-width: 12em;
}
</style>
